export default "/images/cf955a216963be2ce8c02b3906673af9.avif";